import axios from "axios"
import { __GetContentTypeConfigNew } from "../utils/getters/gettersV2";
import { getTenant } from "../../src/TENANT_CONFIGS";




export const validationPlugin = async ({value, passValidationErrorToFormValidation, content}) => {
    try{
        const tenant = getTenant();
        const contentType = content.meta.kp_content_type;
        const tenantContentTypesWithDuplicationCheck = {
            ved: {
                newsReports: {
                    contentTypesToCheck: ["newsReports"],
                    valuePathToLink: "main.link.url",
                },
                proceedings: {
                    contentTypesToCheck: ["proceedings"],
                    valuePathToLink: "main.link.url",
                },
            },
            nkms: {
                reports: {
                    contentTypesToCheck: ["reports", "researchAndEvaluationReports", "programmaticAssetsTemplates"],
                    valuePathToLink: "main.attachALinkToTheDocument",
                },
                researchAndEvaluationReports: {
                    contentTypesToCheck: ["reports", "researchAndEvaluationReports", "programmaticAssetsTemplates"],
                    valuePathToLink: "main.linkToDocumentOnGoogleDrive",
                },
                programmaticAssetsTemplates: {
                    contentTypesToCheck: ["reports", "researchAndEvaluationReports", "programmaticAssetsTemplates"],
                    valuePathToLink: "main.linkToDocument.url",
                },
                trainingReports: {
                    contentTypesToCheck: ["trainingReports"],
                    valuePathToLink: "main.linkToDocument",
                },
            },
        };

        const configForContentTypesToCheck = tenantContentTypesWithDuplicationCheck[tenant];
        const contentTypesToCheck = configForContentTypesToCheck[contentType]?.contentTypesToCheck;
        if(!contentTypesToCheck) return null;

        const excludeIds = [content._id];

        /** below two lines is to ignore this 'no duplicate' rule between clones of the same document. */
        const ogDocId = content.kp_pre_mod_doc || content.kp_og_published_doc; //if this exists, it suggests this doc is either an under mod clone or an edit pbl clone
        if(ogDocId) excludeIds.push(ogDocId);
        
        const sanitizeUrl = (url) => {
            return url
                .replace(/^https?:\/\//, "") // Remove http/https
                .replace(/\/$/, "") // Remove trailing slash if any
                .replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // escape special regex characters
        };
        
        const urlPattern = `^(?:https?:\/\/)?${sanitizeUrl(value)}\\/?$`; // to match with or without protocol

        const result = await Promise.all(contentTypesToCheck.map(async (ct) => {
            const valuePathToLink = configForContentTypesToCheck[ct].valuePathToLink;
            const exclude = { _id: { $nin: excludeIds } };
            const configs = {
                findQuery: {
                    [valuePathToLink]: {
                        // has a document with link that matches the link being shared in THIS document
                        $regex: urlPattern,
                        $options: 'i'
                    },
                    kp_published_status: 'published', //should be published
                    ...(ct === contentType ? exclude : {}) //shouldnt be THIS doc and its clones
                },
                projection: {
                    _id: 1,
                    meta: 1,
                },
                limit: 1,
                contentTypes: [ct], // we have to fetch individually, because the valuePaths to link are different for templates
            };

            return axios.post(`/api/discovery/getData`, {
                configs: JSON.stringify(configs)
            });
        }));

        const foundDuplicate = result.map(res => res.data?.data?.[0]).filter(Boolean)[0]; // we need only one document
        if(foundDuplicate){
            const contentTypeDisplay = __GetContentTypeConfigNew(foundDuplicate.meta.kp_content_type)?.general?.content?.singular || "";
            let errorObj = {
                type: 'error', 
                msg: `This ${contentTypeDisplay} report has been published before.`, 
                link: { 
                    text: 'View Duplicate', 
                    to: `${process.env.NODE_ENV === 'production'
                        ? `${window.location.protocol}//${window.location.hostname}`
                        : 'http://localhost:3000'}/published-page/${foundDuplicate.meta.kp_content_type}?id=${foundDuplicate._id}`
                }
            }
            if(passValidationErrorToFormValidation) passValidationErrorToFormValidation(errorObj.type)
            return errorObj
        }
        //else
        return undefined
        // return res;
    }catch(err){
        console.log({err})
    }
}